<h1 mat-dialog-title>{{ 'DOCUMENT.DLG_LEAVE_TITLE' | translate }}</h1>
<div mat-dialog-content>
  {{ 'DOCUMENT.DLG_LEAVE_MESSAGE' | translate }}
</div>
<div mat-dialog-actions>
  <button mat-button (click)="save()" type="button">
    {{ 'DOCUMENT.DLG_LEAVE_SAVE' | translate }}
  </button>
  <button mat-button (click)="discard()" type="button">
    {{ 'DOCUMENT.DLG_LEAVE_DISCARD' | translate }}
  </button>
  <button mat-button (click)="cancel()" type="button">
    {{ 'DIALOGS.CANCEL' | translate }}
  </button>
</div>
